import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { useAlertsStore } from "./AlertsStore/alertsStore";
import { NavigateFunction } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

const NotesSection = ({
  heading,
  notes,
  loading,
  emptyText,
}: {
  heading: string;
  notes: string;
  loading: boolean;
  emptyText: string;
}) => (
  <section aria-label={heading} className="mb-4 last:mb-0">
    <h3 className="mb-1 font-mulish text-[14px] font-bold text-actuate-blue">
      {heading}
    </h3>
    {loading ? (
      <div className="flex min-h-[40px] items-center justify-center">
        <ThemeProvider theme={theme}>
          <CircularProgress color="primary" size={24} />
        </ThemeProvider>
      </div>
    ) : (
      <DialogContentText sx={{ whiteSpace: "pre-line" }}>
        {notes || emptyText}
      </DialogContentText>
    )}
  </section>
);

export const ViewSiteProtocolDialog = () => {
  const {
    siteNotes,
    viewSiteProtocolDialogOpen,
    setViewSiteProtocolDialogOpen,
    retrievingSiteNotes,
    cameraNotes,
    retrievingCameraNotes,
  } = useAlertsStore();
  const handleClose = () => {
    setViewSiteProtocolDialogOpen(false);
  };

  return (
    <Dialog
      open={viewSiteProtocolDialogOpen}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={"xs"}
    >
      <DialogTitle>Protocol / Notes</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ minHeight: "100px" }}>
        <NotesSection
          heading="Site Notes / Protocol"
          notes={siteNotes}
          loading={retrievingSiteNotes}
          emptyText="No site notes."
        />
        <NotesSection
          heading="Camera Notes / Protocol"
          notes={cameraNotes}
          loading={retrievingCameraNotes}
          emptyText="No camera notes."
        />
      </DialogContent>
    </Dialog>
  );
};
